import { render, staticRenderFns } from "./SelectMetric.vue?vue&type=template&id=2e4b427a&scoped=true&"
import script from "./SelectMetric.vue?vue&type=script&lang=js&"
export * from "./SelectMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b427a",
  null
  
)

export default component.exports